import createDocumentResource from 'src/actions/shared/createDocumentResource';

enum AgentPhonePreferences {
  'BROWSER',
  'DIRECT_DIAL',
  'NONE',
  'STATION',
}

enum SmsPreferenceType {
  'ON',
  'OFF',
  'FORBIDDEN',
}
enum PhoneNumberType {
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OFFICE = 'OFFICE',
  OTHER = '',
}

export class PhoneNumber {
  original: string;
  normalized: string;
  extension: string;
  regionCode: string;
  label: string;
  primary: Boolean;
  smsPreference: SmsPreferenceType;
  type: PhoneNumberType;
}

export class AgentVoiceConfiguration {
  stationId: string;
  phone: PhoneNumber;
  preference: AgentPhonePreferences;
}

export interface AgentProfile {
  id: string;
  version: number;
  name: string;
  avatarUrl: string;
  email: string;
  twitter: string;
  disabledAt: string;
  voiceConfiguration: AgentVoiceConfiguration;
}

const agentProfileResource = createDocumentResource<AgentProfile>({
  name: 'agentProfile',
  endpoint: 'v3/orgs/:orgId/agent-profiles/:agentId',
});
export default agentProfileResource;
